import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, CardContent, Grid, Typography } from '../../../../components/mui/Core/index'
import ChangeNameModal from '../ChangeNameModal/change-name-modal'
import SubHeader from '../../../../components/SubHeader/sub-header'
import Constants from '../../../../constants/en.json'
import { hasRole } from '../../../../utils/user-utils'
import { userRoleConstants } from '../../../../constants/user-role-constant'

function PersonalInformationCard({ handleSubmitUpdatedName }) {
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const fullName = `${authenticatedUser?.firstName} ${authenticatedUser?.lastName}`
  const clientName = `${authenticatedUser?.clientName}`
  const email = `${authenticatedUser?.email}`
  const isAdmin = hasRole({ role: userRoleConstants.LSL_ADMIN, roles: authenticatedUser?.roles })

  const cardStyle = {
    minWidth: '496px',
    width: 'fit-content',
    padding: '0',
    borderRadius: '12px !important',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.3) !important',
    mt: '18px',
    py: 0,
  }
  const cardContentStyle = {
    padding: '10px 25px 18px !important',
  }

  const subHeaderContainerStyle = {
    display: 'flex',
    mt: '3px',
    width: '120px',
  }

  const fullNameContainerStyle = {
    display: 'flex',
    justifyContent: 'right',
    mt: '3px',
    flexGrow: 1,
  }

  const clientNameContainerStyle = {
    display: 'flex',
    justifyContent: 'right',
    mt: '3px',
    flexGrow: 1,
  }
  const clientNameStyle = {
    textAlign: 'right',
  }

  const emailContainerStyle = {
    display: 'flex',
    justifyContent: 'right',
    mt: '3px',
    flexGrow: 1,
  }

  const changeNameModalContainerStyle = {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px !important',
    paddingTop: '10px !important',
    width: '100px',
  }

  return (
    <Card id='personal-info-card' sx={cardStyle}>
      <CardContent sx={cardContentStyle}>
        <SubHeader title={Constants.accountSettings.personalInformation.TITLE} />
        <Grid container spacing={1}>
          <Grid sx={subHeaderContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.accountSettings.personalInformation.NAME_SUBHEADER}:
            </Typography>
          </Grid>
          <Grid sx={fullNameContainerStyle}>
            <Typography variant='cardMessage'>{fullName}</Typography>
          </Grid>
          <Grid sx={changeNameModalContainerStyle}>
            <ChangeNameModal handleSubmitUpdatedName={handleSubmitUpdatedName} />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid sx={subHeaderContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.accountSettings.personalInformation.ORGANIZATION_SUBHEADER}:
            </Typography>
          </Grid>
          <Grid sx={clientNameContainerStyle}>
            <Typography variant='cardMessage' sx={clientNameStyle}>
              {isAdmin
                ? Constants.accountSettings.personalInformation.LIFESCIENCE_LOGISTICS
                : clientName}
            </Typography>
          </Grid>
          <Grid sx={changeNameModalContainerStyle} />
        </Grid>
        <Grid container spacing={1}>
          <Grid sx={subHeaderContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.accountSettings.personalInformation.EMAIL_SUBHEADER}:
            </Typography>
          </Grid>
          <Grid sx={emailContainerStyle}>
            <Typography variant='cardMessage'>{email}</Typography>
          </Grid>
          <Grid sx={changeNameModalContainerStyle} />
        </Grid>
      </CardContent>
    </Card>
  )
}

PersonalInformationCard.propTypes = {
  handleSubmitUpdatedName: PropTypes.func.isRequired,
}

export default PersonalInformationCard
